module.exports = "/static/Images/es/Tree.png";